
window.body = document.querySelector('body');
window.html = document.querySelector('html');

window.compareNotify = () => {
    return {
        openNotification: false,
        openNotificationModal() {
            if(window.innerWidth < 768){
                body.classList.add('modal-open-compare')
                html.classList.add('modal-open-compare')
            }
            // body.classList.add('overflow-hidden')
            // html.classList.add('overflow-hidden')
            this.openNotification = !this.openNotification
            if (!this.openNotification) {
                this.closeNotificationModal();
            }
        },
        closeNotificationModal() {
            if(window.innerWidth < 768){
            body.classList.remove('modal-open-compare')
            html.classList.remove('modal-open-compare')
            }
            // body.classList.remove('overflow-hidden')
            // html.classList.remove('overflow-hidden')
            this.openNotification = false
        }
    }
}

window.humburgerMenu = () => {
    return {
        open_menu: false,
        openMenu() {
            body.classList.add('modal-open')
            html.classList.add('modal-open')
            this.open_menu = !this.open_menu
            if (!this.open_menu) {
                this.closeMenu();
            }
        },
        closeMenu() {
            body.classList.remove('modal-open')
            html.classList.remove('modal-open')
            this.open_menu = false
        }

    }
}